module.exports = __webpack_public_path__ + "static/media/Location_Book-Page47.bbd63b98.png";